import { notify } from 'utils/reduxUtils';

export const types = {
  NESTING_REQUEST_ERROR:
    'modules/common/forms/materialWidget/sheet/NESTING_REQUEST_ERROR',
  NESTING_REQUEST_SUBMIT:
    'modules/common/forms/materialWidget/sheet/NESTING_REQUEST_SUBMIT',
  NESTING_REQUEST_SUCCESS:
    'modules/common/forms/materialWidget/sheet/NESTING_REQUEST_SUCCESS',
  ON_UPDATE_PART_FILE_PACKET:
    'modules/common/forms/materialWidget/sheet/ON_UPDATE_PART_FILE_PACKET',
  RECEIVE_CACHED_NESTING_VALUES:
    'modules/common/forms/materialWidget/sheet/RECEIVE_CACHED_NESTING_VALUES',
  RECEIVE_IS_MOUNTED:
    'modules/common/forms/materialWidget/sheet/RECEIVE_IS_MOUNTED',
  RECEIVE_NESTING_RESULT:
    'modules/common/forms/materialWidget/sheet/RECEIVE_NESTING_RESULT',
  RECEIVE_SHEETS: 'modules/common/forms/materialWidget/sheet/RECEIVE_SHEETS',
  RESET: 'modules/common/forms/materialWidget/sheet/RESET',
  RESET_SHEETS: 'modules/common/forms/materialWidget/sheet/RESET_SHEETS',
  SHEET_REQUEST_ERROR:
    'modules/common/forms/materialWidget/sheet/SHEET_REQUEST_ERROR',
  SHEET_REQUEST_SUBMIT:
    'modules/common/forms/materialWidget/sheet/SHEET_REQUEST_SUBMIT',
  SHEET_REQUEST_SUCCESS:
    'modules/common/forms/materialWidget/sheet/SHEET_REQUEST_SUCCESS',
};

export const sheetWidget = {
  onUpdatePartFilePacket: ({ partFilePacket }) => ({
    type: types.ON_UPDATE_PART_FILE_PACKET,
    payload: { partFilePacket },
  }),
  receiveIsMounted: ({ isMounted }) => ({
    type: types.RECEIVE_IS_MOUNTED,
    payload: { isMounted },
  }),
  receiveNestingResult: ({ nestingResult }) => ({
    type: types.RECEIVE_NESTING_RESULT,
    payload: { nestingResult },
  }),
  reset: () => ({
    type: types.RESET,
  }),
};

export const sheetRequest = {
  submit: ({
    edgeBuffer,
    materialId,
    partLength,
    partThickness,
    partWidth,
    thicknessTolerance,
  }) => ({
    type: types.SHEET_REQUEST_SUBMIT,
    payload: {
      edgeBuffer,
      materialId,
      partLength,
      partThickness,
      partWidth,
      thicknessTolerance,
    },
  }),
  success: () => ({
    type: types.SHEET_REQUEST_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.SHEET_REQUEST_ERROR,
      payload: error,
    }),
    'Sheet Request Error',
  ),
  receive: ({ sheets }) => ({
    type: types.RECEIVE_SHEETS,
    payload: { sheets },
  }),
  reset: () => ({
    type: types.RESET_SHEETS,
  }),
};

export const nestingRequest = {
  submit: ({
    edgeBuffer,
    isManual,
    isSheetSizeManual,
    partBuffer,
    partLength,
    partThickness,
    partWidth,
    quantity,
    sheetCost,
    sheetLength,
    sheetWidth,
    stock,
  }) => ({
    type: types.NESTING_REQUEST_SUBMIT,
    payload: {
      edgeBuffer,
      isManual,
      isSheetSizeManual,
      partBuffer,
      partLength,
      partThickness,
      partWidth,
      quantity,
      sheetCost,
      sheetLength,
      sheetWidth,
      stock,
    },
  }),
  success: () => ({
    type: types.NESTING_REQUEST_SUCCESS,
  }),
  error: notify(
    (error) => ({
      type: types.NESTING_REQUEST_ERROR,
      payload: error,
    }),
    'Nesting Request Error',
  ),
  receiveCachedNestingValues: (values) => ({
    type: types.RECEIVE_CACHED_NESTING_VALUES,
    payload: values,
  }),
};
